<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :pageSize="5"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      :right-btn-options="{ text: 'Add New Request', isHavePermission: true }"
      @changeTitleActionBtn="handleAddNewRequest"
      :row-class-name="tableRowClassName"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a
          style="color: grey"
          href="javascript:void(0)"
          v-if="tableRow.row.bpmType === 1"
        >
          {{ tableRow.row.bpmId }}
        </a>
        <a
          href="javascript:void(0)"
          @click="handleClickHref(tableRow.row)"
          v-else
        >
          {{ tableRow.row.bpmId }}
        </a>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{
          tableRow.row.customerType === 1
            ? 'Trade'
            : tableRow.row.customerType === 2
            ? 'Eaas'
            : 'Saas'
        }}
      </template>
      <template v-slot:eaasType="{ tableRow }">
        {{
          tableRow.row.eaasType === 1
            ? 'CAPEX'
            : tableRow.row.eaasType === 2
            ? 'OPEX'
            : ''
        }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          @click="handleEditBtn(tableRow.row)"
          v-if="tableRow.row.status === 1 && $storage.getItem('btn')['Modify']"
        >
          Modify
        </a>
        <a
          href="javascript:void(0)"
          @click="handleEditBtn(tableRow.row)"
          v-if="tableRow.row.status === 2 || tableRow.row.status === 3"
        >
          Check
        </a>
      </template>
      <template v-slot:reducedAmount="{ tableRow }">
        <span v-if="tableRow.row.reducedAmount">
          {{ tableRow.row.reducedAmount | formatAmount }}
        </span>
        <span v-else>
          {{ tableRow.row.amount | formatAmount }}
        </span>
      </template>
      <template v-slot:amount="{ tableRow }">
        {{ tableRow.row.amount | formatAmount }}
      </template>
      <template v-slot:total>
        <p style="color: #5a607f">
          Total Active Credit Line: {{ totalActiveCreditLine }}
        </p>
      </template>
    </table-view>
    <el-card header="Ecredit History" style="margin-top: 30px">
      <table-view
        :table-model="tableModel1"
        :table-data="tableData1"
        :row-class-name="tableRowClassName"
        :showPage="false"
      >
        <template v-slot:finishTime="{ tableRow }">
          {{
            tableRow.row.finishTime !== null
              ? tableRow.row.finishTime.slice(0, 10)
              : tableRow.row.finishTime
          }}
        </template>
        <template v-slot:action="{ tableRow }">
          <a
            href="javascript:void(0)"
            class="icon-view1"
            style="margin-left: 10px; color: #3a3f63; font-size: 18px"
            @click="handleView(tableRow.row)"
            v-if="tableRow.row.tran"
          />
        </template>
      </table-view>
    </el-card>
    <el-dialog
      title="Edit"
      :visible.sync="visible"
      width="952px"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <template v-if="dialogStatus === 1">
          <el-form
            label-width="190px"
            ref="form"
            label-suffix=":"
            :inline="true"
            :model="form"
            size="small"
            :rules="rules"
          >
            <div class="content-wrapper">
              <el-form-item label="Credit Line" label-width="95px">
                {{ amount }}
              </el-form-item>
              <el-form-item label="Partial Amount" prop="reducedAmount">
                <el-input v-model="form.reducedAmount" style="width: 220px" />
              </el-form-item>
            </div>
            <div class="content-wrapper">
              <el-form-item label="Expire Date" label-width="100px">
                {{ indateEnd }}
              </el-form-item>
              <el-form-item label="Expire Date" prop="reducedDate">
                <el-date-picker
                  valueFormat="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  v-model="form.reducedDate"
                  style="width: 220px"
                  type="date"
                />
              </el-form-item>
            </div>
            <el-form-item
              label="Remark"
              prop="reducedRemark"
              label-width="90px"
            >
              <el-input
                style="width: 860px; margin-left: 10px"
                type="textarea"
                :rows="4"
                v-model="form.reducedRemark"
              />
            </el-form-item>
          </el-form>
          <customize-button type="primary" @click="handleSaveBtn">
            Confirm
          </customize-button>
        </template>
        <table-view
          class="dialog"
          ref="tableList2"
          :tableModel="tableModel2"
          :tableData="tableData2"
          :pages="pages2"
        />
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDialogTableData,
  getTableData,
  saveForm,
  getHistoryData,
  getCompanyInfo,
  getDescTran,
} from './api'

const eaasType = {
  slotName: 'eaasType',
  label: 'Eaas Type',
  width: 200,
}

export default {
  data() {
    const tableModel1 = [
      {
        width: 200,
        label: 'Tran#',
        prop: 'tran',
      },
      {
        width: 150,
        label: 'Transaction Type',
        prop: 'approveTypeStr',
      },
      {
        width: 170,
        label: 'Expiry Date',
        prop: 'indateEnd',
      },
      {
        width: 170,
        label: 'Effective Date',
        slotName: 'finishTime',
      },
      {
        width: 170,
        label: 'Credit Line',
        prop: 'amount',
      },
      {
        width: 180,
        label: 'Partial Amount',
        prop: 'reducedAmount',
      },
      {
        minWidth: 170,
        label: 'Source',
        prop: 'sourceStr',
      },
      {
        width: 120,
        label: 'Modified by',
        prop: 'approver',
      },
      {
        width: 80,
        label: 'Action',
        slotName: 'action',
        fixed: 'right',
      },
    ]
    const searchModel = [
      {
        label: 'Tran#',
        type: 'input',
        key: 'bpmId',
        layout: {
          md: 24,
          lg: 10,
        },
      },
      {
        label: 'Expiry Date',
        type: 'time',
        key: 'time',
        layout: {
          md: 24,
          lg: 10,
        },
      },
    ]

    const tableModel = [
      {
        width: 200,
        label: 'Tran#',
        slotName: 'bpmId',
      },
      { slotName: 'customerType', label: 'Customer Type', width: 200 },
      {
        width: 150,
        label: 'Transaction Type',
        prop: 'approveTypeStr',
      },
      {
        width: 170,
        label: 'Expiry Date',
        prop: 'indateEnd',
      },
      {
        minWidth: 150,
        label: 'Effective Date',
        prop: 'finishTime',
      },
      {
        width: 170,
        label: 'Credit Line',
        slotName: 'amount',
      },
      {
        width: 180,
        label: 'Partial Amount',
        slotName: 'reducedAmount',
      },
      {
        width: 100,
        label: 'Approver',
        prop: 'approver',
      },
      {
        minWidth: 170,
        label: 'Last Modified',
        prop: 'reviewDate',
      },
      {
        minWidth: 170,
        label: 'Source',
        prop: 'sourceStr',
      },
      {
        width: 80,
        label: 'Action',
        slotName: 'action',
        fixed: 'left',
      },
    ]
    const tableModel2 = [
      {
        label: 'Partial Amount',
        prop: 'targetAmount',
      },
      {
        label: 'Expire Date',
        prop: 'targetIndate',
      },
      {
        label: 'Last Modified Time',
        prop: 'createTime',
      },
      {
        label: 'Remark',
        prop: 'remark',
      },
      {
        label: 'Modified by',
        prop: 'operator',
      },
    ]
    return {
      amount: '',
      indateEnd: '',
      maxValues: null,
      searchModel,
      tableModel,
      tableModel1,
      tableHistoryData: {},
      tableData: [],
      tableData1: [],
      companyInfoVO: [],
      pages: {},
      tableModel2,
      tableData2: [],
      pages2: {},
      form: { reducedAmount: '', reducedRemark: '', reducedDate: '' },
      rules: {
        reducedAmount: [
          { required: true, message: 'cannot be empty', trigger: 'blur' },
        ],
        reducedDate: [
          { required: true, message: 'cannot be empty', trigger: 'change' },
        ],
        reducedRemark: [
          { required: true, message: 'cannot be empty', trigger: 'blur' },
        ],
      },
      visible: false,
      HisVisible: false,
      isTableLoading: true,
      companyId: this.$route.params.customerId,
      dialogStatus: 1,
      totalActiveCreditLine: 0,
    }
  },
  mounted() {
    this.initTable()
    this._getHistoryData()
    if (this.$store.state.source === 2) {
      this.tableModel.splice(1, 1)
    }
  },
  methods: {
    handleView(row) {
      this.$router.push({
        // name: 'creditLineDetail', // 对应路由
        path: `/customer-analysis/customer-management/credit-line-detail`,
        query: {
          id: row.id,
        },
      })
    },
    async _getHistoryData() {
      const params = { companyId: this.companyId }
      const res = await getHistoryData(params)
      this.tableData1 = res.creditLinePageVOList
      this.totalActiveCreditLine = res.totalCreditLine
      this.tableData1.map(item => {
        item.amount = this.$utils.formatAmount(item.amount)
        item.reducedAmount = this.$utils.formatAmount(item.reducedAmount)
      })
    },
    async handleHisBtn(res) {
      this.HisVisible = true
      this.tableHistoryData = await getDescTran(res.tran)
    },
    tableRowClassName({ row }) {
      if (row.status === 1) {
        return 'success-row'
      } else {
        return 'warning-row'
      }
    },
    handleClickHref(tableRow) {
      this.$storage.setItem('bpmId', tableRow.bpmId)
      if (tableRow.sourceStr === 'CSS') {
        let routeUrl = this.$router.resolve({
          path: `/credit-management/css-audit/single-audit?bpmId=${tableRow.bpmId}`, // 对应路由
        })
        window.open(routeUrl.href, '_blank')
      } else {
        let routeUrl = this.$router.resolve({
          path: `/credit-management/credit-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    handleEditBtn(res) {
      this.dialogStatus = res.status
      this.visible = true
      this.$nextTick(() => {
        this.amount = res.amount
        this.indateEnd = res.indateEnd
        this.formId = res.id
        const params = this.$refs.tableList2.getSearchData()
        this._getDialogTableData({ ...params, id: res.id })
      })
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData({ ...params, companyId: this.companyId })
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData({ ...params, companyId: this.companyId })
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        params.indateStart = params.startTime
        params.indateEnd = params.endTime
        delete params.endTime
        delete params.startTime
        const { data, page } = await getTableData(params)
        if (data[0].customerType === 2) {
          this.tableModel.splice(2, 0, eaasType)
        }
        this.tableData = data
        this.tableData.map(item => {
          item.finishTime = item.finishTime.split(' ')[0]
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    async _getDialogTableData(params) {
      try {
        const { data, page } = await getDialogTableData(params)
        this.tableData2 = data
        this.pages2 = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handlePageChange(params) {
      this._getTableData({ ...params, companyId: this.companyId })
    },
    handleClose() {
      this.$refs.form?.resetFields?.()
      this.tableData2 = []
    },
    async handleSaveBtn() {
      try {
        const valid = this.$refs.form.validate()
        if (valid) {
          await saveForm({ ...this.form, id: this.formId })
          this.$message.success('success')
          this.visible = false
          this.initTable()
        }
      } catch (err) {
        console.error(err)
      }
    },
    async _getCompanyInfo() {
      const res = await getCompanyInfo(this.$route.params.customerId)
      this.companyInfoVO = res.companyInfoVO
    },
    async handleAddNewRequest() {
      //
      // const res = await getCompanyInfo(this.$route.params.customerId)
      // this.companyInfoVO = res.companyInfoVO
      if (this.$store.state.source === 2) {
        this.$router.push(
          `/credit-management/css-request/${this.$route.params.customerId}/detail`,
        )
      } else {
        this.$router.push(
          `/credit-management/credit-request/${this.$route.params.customerId}/detail`,
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 872px;
  display: flex;
  justify-content: space-between;
  .el-form-item {
    flex: 1;
  }
}
.dialog {
  :deep(.card) {
    padding: 0;
  }
}
.decisionComments {
  vertical-align: bottom;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
